import { ResponseModel } from 'projects/core/src/lib/core/model/ResponseModel';
import { AlterarSenhaPage } from './alterar-senha.page';
import { AlterarSenhaModel } from 'projects/core/src/lib/core/model/AlterarSenhaModel';
import { ThrowError } from 'projects/core/src/lib/core/ThrowError';
import { TratamentoGatewayService } from 'projects/core/src/lib/core/TratamentoGatewayService';

export class AlterarSenhaViewModel {

    alterarSenhaModel = new AlterarSenhaModel()
    context: AlterarSenhaPage

    setContext(context: AlterarSenhaPage) {
        this.context = context
    }

    getContext(): AlterarSenhaPage {
        return this.context
    }

    async enviaAlterarSenha(alterarSenhaModel: AlterarSenhaModel) {
        let retorno = await this.alterarSenhaModel.enviaAlterarSenha(alterarSenhaModel)
        try {
            retorno = new TratamentoGatewayService(this.getContext()).builder(retorno)
            if (retorno.status == ResponseModel.STATUS_OK) {
                this.getContext().mensagemSucessoAlteracao('Senha alterada com sucesso!')
            } else {
                this.getContext().mensagemFalhaAlteracao(retorno.data.error)
            }
        } catch (e) {}
    }
}